"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useFeature = _interopRequireDefault(require("../Hooks/useFeature"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Feature = function Feature(_ref) {
  var name = _ref.name,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled,
    _ref$negative = _ref.negative,
    negative = _ref$negative === void 0 ? false : _ref$negative,
    children = _ref.children;
  var flagEnabled = (0, _useFeature["default"])(name, enabled);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, flagEnabled && !negative || !flagEnabled && negative ? children : null);
};
var _default = exports["default"] = Feature;